// extracted by mini-css-extract-plugin
export default {"summaryTable":"summary-page_summaryTable__4egMx","summaryTableCol":"summary-page_summaryTableCol__iZnkp"};